import { Container, createStyles, Group, SimpleGrid, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import API from '../../apis/api';
import CategoryNavbar from '../../components/category-navbar';
import ImageStorageService from '../../services/ImageStorageService';
import { GetTranslated, TranslateField } from '../../types/translate-field';
import { GetCatgoryResponse, TranslateCategory } from '../../apis/response/GetCategoryResponse';
import ProductCard, { ProductCardProp } from '../../components/product-card';

import NavBar, { NavBarItem } from '../../components/navbar';
import DefaultContainer from '../../components/container';
import { CurrentLocale } from '../../App';
import { useParams } from 'react-router-dom';
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from '../../apis/response/GetNavbarCategoriesResponse';
import { GetPortalResponse, ToPortalLink } from '../../apis/response/GetPortalResponse';
import { SharedProps } from '../../types/shared-props';
import { ChineseTitleFormat } from '../../services/SpecialFormatService';

const useStyles = createStyles((theme) => ({
    card: {
        width: '100%'
    },
    grid: {
        paddingBottom: 20,
    },

    hero: {
        position: 'relative',
        //   backgroundImage:
        //     'url(https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: 450,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: '10%',

        [theme.fn.smallerThan('sm')]: {
            padding: '15px',
            justifyContent: 'center',
        },
    },

    container: {
        width: 300,
        height: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        alignSelf: 'center',
        zIndex: 1,
        position: 'relative',
        backgroundColor: theme.colors.offWhite[0],
        opacity: 50,
        padding: 30,
        margin: 0,
    },

    title: {
        color: theme.colors.hkc[1],
        fontSize: theme.other.layout.title.fontSize,
        fontFamily: theme.other.titleFont,
        fontWeight: theme.other.layout.title.fontWeight,
        lineHeight: theme.other.layout.title.lineHeight,
        textAlign: 'left',
    },

    description: {
        color: theme.colors.hkc[2],
        textAlign: 'left',
        fontSize: 20,
    },

    slash: {
        height: theme.other.layout.slashHeight,
        backgroundColor: theme.colors.hkc[0],
        width: '80%',
        marginTop: 25,
    },

    dividerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        zIndex: 4
    },
    dividerBox: {
        flex: 1,
        flexGrow: 3,
        backgroundColor: theme.colors.hkc[1],
        height: theme.other.layout.slashHeight
    },
    dividerText: {
        padding: '25px 40px',
        maxWidth: 300,
        whiteSpace: 'break-spaces',
        color: theme.colors.hkc[0],
        fontWeight: 650,
        fontSize: theme.other.layout.sectionTitleFontSize,
        fontFamily: theme.other.titleFont
    },
}));

interface CategoryPageProps {
    imgBinaryList?: ProductCardProp[]
    cover?: string
    catInfo?: TranslateField
    catId?: string
}


const Category = () => {
    const { classes } = useStyles()
    const { t } = useTranslation('common', { keyPrefix: 'section' })
    const [loading, setLoading] = useState(true)

    const init: CategoryPageProps & SharedProps = {}
    const [props, setProps] = useState(init)

    // const data = props.categories
    const { catId } = useParams()

    const fetchData = async () => {
        const imageService = new ImageStorageService()
        const imgBinaryList = await imageService.GetDepartmentList(`${catId}`)
        const cover = await imageService.GetRandomCatCover(`${catId}`)
        const res: GetCatgoryResponse = (await API.Category.GetCat(`${catId}`)).obj
        const catInfo = TranslateCategory(res.items[0])
        const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj
        const categories = TransformToCategoryMenu(c.items)
        const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
        const useful = usefulRes.items.map(x => ToPortalLink(x))
        const tmp_catId = parseInt(catId?catId:"")
        const navTree: NavBarItem[] = [
            { title: catInfo, slug: `/Category/${catId}`, catId:tmp_catId }
        ]

        imgBinaryList.sort((x,y)=>{
            console.log(x.display_order)
            if (x.display_order > y.display_order) {
              return 1;
            }
            if (x.display_order < y.display_order) {
                return -1;
            }
            return 0;
        })

        const newProps = {
            catId, catInfo, cover, imgBinaryList, navTree, categories, useful
        }
        console.log("newProps")
        console.log(newProps)
        setProps(newProps)
    }
    useEffect(() => {
        fetchData().then(() => setLoading(false))
    }, [])

    const subCat = props.imgBinaryList

    return (
        <DefaultContainer loading={loading}>
            {
                props.categories && props.useful ?
                    <CategoryNavbar data={props.categories} useful={props.useful} />
                    : <></>
            }
            <NavBar navTree={props.navTree ?? []} />

            <div className={classes.hero} style={{ backgroundImage: `url('${props.cover}')` }}>
                <Container className={classes.container}>
                    <Group style={{width: '100%'}}>
                        <Title className={classes.title} order={3} dangerouslySetInnerHTML={{__html: ChineseTitleFormat(GetTranslated(props.catInfo, CurrentLocale))}}>
                           
                        </Title>
                        <div className={classes.slash}></div>
                    </Group>
                </Container>
            </div>

            <div className={classes.dividerContainer}>
                <div className={classes.dividerBox}></div>
                <Text className={classes.dividerText}>
                    {t('department')}
                </Text>
                <div className={classes.dividerBox}></div>
            </div>

            <SimpleGrid className={classes.grid} cols={4} spacing={'lg'} breakpoints={[{ maxWidth: 'lg', cols: 3 }, { maxWidth: 'md', cols: 2 }, { maxWidth: 'sm', cols: 1 }]}>
                {
                    subCat ?
                        subCat.map((x: ProductCardProp) => {
                            return <ProductCard key={x.slug} prop={x} className={classes.card} />
                        })
                        : []
                }
            </SimpleGrid>
        </DefaultContainer>
    )
}

export default Category

